import { PagingType, UTable } from '@components/common/UTable/UTable';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { useGetHistoryQuery } from '@/api/pharmacy/api';
import { columns } from '@/pages/Pharmacy/components/history/columns.config';
import { filterSchema } from '@/pages/Pharmacy/components/history/filters.config';
import { TFilters } from '@/shared/api/types';
import { pharmacy } from '@/shared/security/permissions/pharmacy';
import { mapTableIndexWithPage } from '@/utils/utils';

export const MonitoringHistory = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const orgId = searchParams.get('organizationId') || '';

  const [filters, setFilters] = useState<TFilters>();
  const [paging, setPaging] = useState<PagingType>({ page: 0, size: 10 });

  const { data, isFetching } = useGetHistoryQuery(
    {
      filters: {
        ...filters,
        organizationId: orgId,
      },
      paging,
      sort: [{ key: 'createdAt', order: 'desc' }],
    },
    { skip: !orgId },
  );

  return (
    <UTable
      size={'small'}
      data={mapTableIndexWithPage(data?.content, paging)}
      columns={columns}
      loading={isFetching}
      paging={paging}
      total={data?.totalElements}
      onPagingChange={setPaging}
      buttons={[
        {
          text: 'Назад',
          action: () => navigate(-1),
        },
      ]}
      filter={{
        filters,
        schema: filterSchema,
        onFilter: (filters) => setFilters(filters),
        onReset: () => setFilters({}),
        security: { permissions: pharmacy.monitoring.viewDrugs },
      }}
    />
  );
};
